
import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditCommune = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [CommuneData, setCommuneData] = useState({});
  const [departements, setDepartements] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [OpenAlert, setOpenAlert] = useState(false);
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [CommuneValue, setCommuneValue] = useState('');
  const [spinner, setSpinner] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const [selectedDepartement, setSelectedDepartement] = useState<any>();
  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...CommuneData };
    item[name] = value;
    setCommuneData(item);
    if (name === 'departement') {
      setSelectedDepartement(value);
     setSelectedRegion(value)
      setSelectedCountry(value)
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (CommuneData['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        CommuneData['name'] = props.commune['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        CommuneData['departement'] = JSON.parse(selectedDepartement);
        const response = httpClient.current?.put(`/api/commune/update`, CommuneData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.communes();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      setSpinner(true);
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    CommuneData['name'] = props.commune['name'];
    setUpdateModal(!UpdateModal);
  };

  useEffect(() => {
    setCommuneData(props.commune);
    setSelectedDepartement(JSON.stringify(props.commune.departement));
    setSelectedRegion(JSON.stringify(props.commune.departement.region))
    setSelectedCountry(JSON.stringify(props.commune.departement.region.country))
  }, [props.commune]);

  useEffect(() => {
    const getDepartements = () => {
      if (!selectedRegion) return;
      httpClient.current?.get(`/api/departement/all`).then((response) => {
        let departements = response.data;
        departements = departements.filter((departement) => departement.region.id === JSON.parse(selectedRegion).id);
        setDepartements(departements);
      });
    };
    getDepartements();
  }, [httpClient, selectedRegion]);



  useEffect(() => {
   
    const getRegions = () => {
      if (!selectedCountry) return;
      httpClient.current?.get(`/api/region/all`).then((response) => {
        let regions = response.data;
        regions = regions.filter((region) => region.country.id === JSON.parse(selectedCountry).id);
        setRegions(regions);
      });
    };
    getRegions();
  }, [selectedCountry]);

  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient,selectedCountry]);

 

  return (
    <>
      <EditButtonIcon
        title={props.t('update_commune')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_commune')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    value={CommuneData['name']}
                    onChange={(event) => setCommuneValue(event.target.value)}
                    placeholder={props.t('placeholder_commune_name')}
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'country_name'}>{props.t('country_name')}</label>
                  <select
                    name="country"
                    id="country"
                    className="form-control"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                    placeholder={props.t('select_country_name')}
                  >
                    <option value="">{props.t('select_country_name')}</option>
                    {countries.map((country, index) => (
                      <option id={country.id} key={index} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                
                <FormGroup className={`form-row ${selectedCountry ? 's' : 'd-none'}`}>
                  <label htmlFor={'region_name'}>{props.t('region_name')}</label>
                  <select
                    name="region"
                    id="region"
                    className="form-control"
                    value={selectedRegion}
                    onChange={(e) => setSelectedRegion(e.target.value)}
                  >
                    <option value="">{props.t('select_region_name')}</option>

                    {regions.map((region, index) => (
                      <option id={region.id} key={index} value={JSON.stringify(region)}>
                        {region.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <FormGroup className={`form-row ${selectedRegion ? 's' : 'd-none'}`}>
                  <label htmlFor={'region_name'}>{props.t('departement_name')}</label>
                  <select
                    name="department"
                    id="department"
                    className="form-control"
                    value={selectedDepartement}
                    onChange={(e) => setSelectedDepartement(e.target.value)}
                  >
                    <option value="">{props.t('select_departement_name')}</option>
                    {departements.map((departement, index) => (
                      <option id={departement.id} key={index} value={JSON.stringify(departement)}>
                        {departement.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
               
              
                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={UpdateModalToggle}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditCommune);
